export default {
  computed: {
    selectedCycle() {
      return this.$store.state.cycleId;
    }
  }
};